export default __webpack_public_path__ + "static/media/inline_logo_color_128.080d28bb.png";